import { findNearestExchangeRate } from './currency.js';

export function getGeneralLedgerData(context) {
    const {
        assets = [],
        cashaccounts = [],
        interaccounttransfers = [],
        transactions = [],
        journalentries = [],
        purchaseinvoices = [],
        productionorders = [],
        salesinvoices = [],
        assetaccounts = [],
        liabilityaccounts = [],
        equityaccounts = [],
        expenseaccounts = [],
        clients,
        suppliers,
        staff,
        items,
        startdate,
    } = context;

    let resultsArray = [];

    assets.forEach(asset => {
        let openingbalance = parseFloat(asset.amount || 0);

        if (!openingbalance) return;

        let amount = Math.abs(openingbalance);

        if (openingbalance > 0) {
            resultsArray.push({
                ts: startdate,
                name: 'Opening balance - ' + asset.name,
                accounttype: 'assetaccounts',
                accountid: asset.assetaccountid,
                debit: amount,
                credit: 0,
                currencyid: asset.currencyid,
                type: 'assets',
                id: asset.id,
            });

            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance - Assets',
                accounttype: 'equityaccounts',
                accountid: 'opening_balance_equity',
                debit: 0,
                credit: amount,
                currencyid: asset.currencyid,
                type: 'assets',
                id: asset.id,
            });
        }

        if (openingbalance < 0) {
            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance - Assets',
                accounttype: 'equityaccounts',
                accountid: 'opening_balance_equity',
                debit: amount,
                credit: 0,
                currencyid: asset.currencyid,
                type: 'assets',
                id: asset.id,
            });

            resultsArray.push({
                ts: startdate,
                name: 'Opening balance - ' + asset.name,
                accounttype: 'assetaccounts',
                accountid: asset.assetaccountid,
                debit: 0,
                credit: amount,
                currencyid: asset.currencyid,
                type: 'assets',
                id: asset.id,
            });
        }
    });

    suppliers.forEach(supplier => {
        let liabilityaccountid = supplier?.liabilityaccountid;

        let openingbalance = parseFloat(supplier.openingbalance || 0);
        if (!openingbalance) return;
        let amount = Math.abs(openingbalance);

        if (openingbalance > 0) {
            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance',
                accounttype: 'suppliers',
                accountid: supplier.id,
                debit: 0,
                credit: amount,
                currencyid: supplier.currencyid,
                type: 'suppliers',
                id: supplier.id,
            });
            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance',
                accounttype: 'liabilityaccounts',
                accountid: liabilityaccountid,
                debit: 0,
                credit: amount,
                currencyid: supplier.currencyid,
                type: 'suppliers',
                id: supplier.id,
            });

            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance - Suppliers',
                accounttype: 'equityaccounts',
                accountid: 'opening_balance_equity',
                debit: amount,
                credit: 0,
                currencyid: supplier.currencyid,
                type: 'suppliers',
                id: supplier.id,
            });
        }

        if (openingbalance < 0) {
            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance',
                accounttype: 'suppliers',
                accountid: supplier.id,
                debit: amount,
                credit: 0,
                currencyid: supplier.currencyid,
                type: 'suppliers',
                id: supplier.id,
            });
            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance',
                accounttype: 'liabilityaccounts',
                accountid: liabilityaccountid,
                debit: amount,
                credit: 0,
                currencyid: supplier.currencyid,
                type: 'suppliers',
                id: supplier.id,
            });

            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance - Suppliers',
                accounttype: 'equityaccounts',
                accountid: 'opening_balance_equity',
                debit: 0,
                credit: amount,
                currencyid: supplier.currencyid,
                type: 'suppliers',
                id: supplier.id,
            });
        }
    });

    interaccounttransfers.forEach(transfer => {
        let cashaccount = cashaccounts.find(cashaccount => cashaccount.id == transfer.to)
        resultsArray.push({
            ts: transfer.ts,
            name: transfer.name,
            accounttype: 'cashaccounts',
            accountid: transfer.from,
            fromtype: 'cashaccounts',
            from: cashaccount?.name || '',
            activity: 'operating',
            debit: 0,
            credit: parseFloat(transfer.fromamount),
            currencyid: transfer.fromcurrencyid,
            type: 'interaccounttransfers',
            id: transfer.id,
        });
        cashaccount = cashaccounts.find(cashaccount => cashaccount.id == transfer.from)
        resultsArray.push({
            ts: transfer.ts,
            name: transfer.name,
            accounttype: 'cashaccounts',
            accountid: transfer.to,
            fromtype: 'cashaccounts',
            from: cashaccount?.name || '',
            activity: 'operating',
            debit: parseFloat(transfer.toamount),
            credit: 0,
            currencyid: transfer.tocurrencyid,
            type: 'interaccounttransfers',
            id: transfer.id,
        });
    });

    cashaccounts.forEach(account => {
        let openingbalance = parseFloat(account.openingbalance || 0);
        if (!openingbalance) return;
        let amount = Math.abs(openingbalance);

        if (openingbalance > 0) {
            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance',
                accounttype: 'cashaccounts',
                accountid: account.id,
                fromtype: 'cashaccounts',
                from: account?.name || '',
                activity: 'openingbalance',
                debit: amount,
                credit: 0,
                currencyid: account.currencyid,
                type: 'cashaccounts',
                id: account.id,
            });

            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance - Cash Account',
                accounttype: 'equityaccounts',
                accountid: 'opening_balance_equity',
                debit: 0,
                credit: amount,
                currencyid: account.currencyid,
                type: 'equityaccounts',
                id: '',
            });
        }

        if (openingbalance < 0) {
            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance - Cash Account',
                accounttype: 'equityaccounts',
                accountid: 'opening_balance_equity',
                debit: amount,
                credit: 0,
                currencyid: account.currencyid,
                type: 'equityaccounts',
                id: '',
            });

            resultsArray.push({
                ts: startdate,
                name: 'Opening Balance',
                accounttype: 'cashaccounts',
                accountid: account.id,
                fromtype: 'cashaccounts',
                from: account?.name || '',
                activity: 'openingbalance',
                debit: 0,
                credit: amount,
                currencyid: account.currencyid,
                type: 'cashaccounts',
                id: account.id,
            });
        }
    });

    transactions
        .forEach(transaction => {
            let amount = parseFloat(transaction.amount);

            if (transaction.type == 'receipt') {
                if (transaction.fromtype == 'clients') {
                    let client = clients.find(client => client.id == transaction.from);
                    let basis = client?.basis;
                    let assetaccountid = client?.assetaccountid
                    if (basis == 'cash') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'incomeaccounts',
                            accountid: 'default_income_account',
                            debit: 0,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: transaction.fromtype,
                            accountid: transaction.from,
                            fromtype: 'clients',
                            from: client.name || '',
                            activity: 'operating',
                            debit: amount,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    if (basis == 'accrual') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'assetaccounts',
                            accountid: assetaccountid,
                            from: client.name || '',
                            debit: 0,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: transaction.fromtype,
                            accountid: transaction.from,
                            fromtype: 'clients',
                            from: client.name || '',
                            activity: 'operating',
                            debit: 0,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        fromtype: 'clients',
                        from: client.name || '',
                        activity: 'operating',
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.fromtype == 'suppliers') {
                    let supplier = suppliers.find(supplier => supplier.id == transaction.from);
                    let basis = supplier?.basis;
                    let liabilityaccountid = supplier?.liabilityaccountid
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: 'liabilityaccounts',
                        accountid: liabilityaccountid,
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    if (basis == 'cash') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: transaction.fromtype,
                            accountid: transaction.from,
                            fromtype: 'suppliers',
                            from: supplier.name || '',
                            activity: 'operating',
                            debit: amount,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    if (basis == 'accrual') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: transaction.fromtype,
                            accountid: transaction.from,
                            fromtype: 'suppliers',
                            from: supplier.name || '',
                            activity: 'operating',
                            debit: 0,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        fromtype: 'suppliers',
                        from: supplier.name || '',
                        activity: 'operating',
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.fromtype == 'assetaccounts') {
                    let assetaccount = assetaccounts.find(assetaccount => assetaccount.id == transaction.from);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: 'assetaccounts',
                        accountid: assetaccount.id,
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        fromtype: 'assetaccounts',
                        from: assetaccount.name || '',
                        activity: 'investing',
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.fromtype == 'liabilityaccounts') {
                    let liabilityaccount = liabilityaccounts.find(liabilityaccount => liabilityaccount.id == transaction.from);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: 'liabilityaccounts',
                        accountid: liabilityaccount.id,
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        fromtype: 'liabilityaccounts',
                        from: liabilityaccount.name || '',
                        activity: 'financing',
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.fromtype == 'equityaccounts') {
                    let equityaccount = equityaccounts.find(equityaccount => equityaccount.id == transaction.from);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: 'equityaccounts',
                        accountid: equityaccount.id,
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        fromtype: 'equityaccounts',
                        from: equityaccount.name || '',
                        activity: 'financing',
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
            }

            if (transaction.type == 'payment') {
                if (transaction.totype == 'expenseaccounts') {
                    let expenseaccount = expenseaccounts.find(expenseaccount => expenseaccount.id == transaction.to);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.fromtype,
                        accountid: transaction.from,
                        fromtype: 'expenseaccounts',
                        from: expenseaccount?.name || '',
                        fromid: expenseaccount?.id || '',
                        activity: 'operating',
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.totype == 'liabilityaccounts') {
                    let liabilityaccount = liabilityaccounts.find(liabilityaccount => liabilityaccount.id == transaction.to);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.fromtype,
                        accountid: transaction.from,
                        fromtype: 'liabilityaccounts',
                        from: liabilityaccount?.name || '',
                        activity: 'operating',
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.totype == 'assetaccounts') {
                    let assetaccount = assetaccounts.find(assetaccount => assetaccount.id == transaction.to);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.fromtype,
                        accountid: transaction.from,
                        fromtype: 'assetaccounts',
                        from: assetaccount?.name || '',
                        activity: 'operating',
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.totype == 'equityaccounts') {
                    let equityaccount = equityaccounts.find(equityaccount => equityaccount.id == transaction.to);
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.fromtype,
                        accountid: transaction.from,
                        fromtype: 'equityaccounts',
                        from: equityaccount?.name || '',
                        activity: 'operating',
                        debit: amount,
                        credit: 0,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                    resultsArray.push({
                        ts: transaction.ts,
                        name: transaction.name,
                        accounttype: transaction.totype,
                        accountid: transaction.to,
                        debit: 0,
                        credit: amount,
                        currencyid: transaction.currencyid,
                        subaccountid: transaction.subaccountid,
                        type: 'transactions',
                        id: transaction.id,
                    });
                }
                if (transaction.beneficiarytype == 'clients') {
                    let client = clients.find(client => client.id == transaction.beneficiaryid);
                    let basis = client?.basis;
                    if (basis == 'cash') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'clients',
                            accountid: transaction.beneficiaryid,
                            debit: amount,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    if (basis == 'accrual') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'clients',
                            accountid: transaction.beneficiaryid,
                            debit: amount,
                            credit: 0,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                }
                if (transaction.beneficiarytype == 'suppliers') {
                    let supplier = suppliers.find(supplier => supplier.id == transaction.beneficiaryid);
                    let basis = supplier?.basis;
                    if (basis == 'cash') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'suppliers',
                            accountid: transaction.beneficiaryid,
                            debit: amount,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    if (basis == 'accrual') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'suppliers',
                            accountid: transaction.beneficiaryid,
                            debit: amount,
                            credit: 0,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                }
                if (transaction.beneficiarytype == 'staff') {
                    let staffmember = staff.find(staffmember => staffmember.id == transaction.beneficiaryid);
                    let basis = staffmember?.basis;
                    if (basis == 'cash') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'staff',
                            accountid: transaction.beneficiaryid,
                            debit: amount,
                            credit: amount,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                    if (basis == 'accrual') {
                        resultsArray.push({
                            ts: transaction.ts,
                            name: transaction.name,
                            accounttype: 'staff',
                            accountid: transaction.beneficiaryid,
                            debit: amount,
                            credit: 0,
                            currencyid: transaction.currencyid,
                            subaccountid: transaction.subaccountid,
                            type: 'transactions',
                            id: transaction.id,
                        });
                    }
                }
            }
        });

    journalentries
        .forEach((entry) => {
            entry.rows.forEach((row) => {
                let debit = parseFloat(row.debit);
                let credit = parseFloat(row.credit);

                if (row.accounttype == 'cashaccounts') {
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: row.accounttype,
                        accountid: row.accountid,
                        fromtype: 'mixed',
                        from: 'mixed',
                        activity: 'mixed',
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                }
                else if (row.accounttype == 'clients') {
                    let client = clients.find(client => client.id == row.accountid);
                    let assetaccountid = clients.find(client => client.id == row.accountid)?.assetaccountid;
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: 'assetaccounts',
                        accountid: assetaccountid,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: row.accounttype,
                        accountid: row.accountid,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                }
                else if (row.accounttype == 'suppliers') {
                    let supplier = suppliers.find(supplier => supplier.id == row.accountid);
                    let liabilityaccountid = suppliers.find(supplier => supplier.id == row.accountid)?.liabilityaccountid;
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: 'liabilityaccounts',
                        accountid: liabilityaccountid,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: row.accounttype,
                        accountid: supplier.id,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                }
                else if (row.accounttype == 'staff') {
                    let staffmember = staff.find(staffmember => staffmember.id == row.accountid);
                    let liabilityaccountid = staff.find(staffmember => staffmember.id == row.accountid)?.liabilityaccountid;
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: 'liabilityaccounts',
                        accountid: liabilityaccountid,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: row.accounttype,
                        accountid: staffmember?.id,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                }
                else {
                    resultsArray.push({
                        ts: entry.ts,
                        name: row.name || entry.name,
                        accounttype: row.accounttype,
                        accountid: row.accountid,
                        debit: debit,
                        credit: credit,
                        currencyid: entry.currencyid,
                        subaccountid: entry.subaccountid,
                        type: 'journalentries',
                        id: entry.id,
                    });
                }
            });
        });

    let cost = {};

    purchaseinvoices
        .forEach(invoice => {
            let invoiceammount = parseFloat(invoice.amount) || 0;

            let supplier = suppliers.find(supp => supp.id == invoice.supplierid);
            let liabilityaccountid = suppliers.find(supp => supp.id == invoice.supplierid)?.liabilityaccountid;
            let basis = suppliers.find(supp => supp.id == invoice.supplierid)?.basis;

            if (basis == 'cash') {
                resultsArray.push({
                    ts: invoice.ts,
                    name: invoice.name,
                    accounttype: 'suppliers',
                    accountid: invoice.supplierid,
                    debit: invoiceammount,
                    credit: invoiceammount,
                    currencyid: invoice.currencyid,
                    subaccountid: invoice.subaccountid,
                    type: 'purchaseinvoices',
                    id: invoice.id,
                });
                resultsArray.push({
                    ts: invoice.ts,
                    name: invoice.name,
                    accounttype: 'liabilityaccounts',
                    accountid: liabilityaccountid,
                    debit: 0,
                    credit: invoiceammount,
                    currencyid: invoice.currencyid,
                    subaccountid: invoice.subaccountid,
                    type: 'purchaseinvoices',
                    id: invoice.id,
                });
            }
            if (basis == 'accrual') {
                resultsArray.push({
                    ts: invoice.ts,
                    name: invoice.name,
                    accounttype: 'suppliers',
                    accountid: invoice.supplierid,
                    debit: 0,
                    credit: invoiceammount,
                    currencyid: invoice.currencyid,
                    subaccountid: invoice.subaccountid,
                    type: 'purchaseinvoices',
                    id: invoice.id,
                });
                resultsArray.push({
                    ts: invoice.ts,
                    name: invoice.name,
                    accounttype: 'liabilityaccounts',
                    accountid: liabilityaccountid,
                    debit: 0,
                    credit: invoiceammount,
                    currencyid: invoice.currencyid,
                    subaccountid: invoice.subaccountid,
                    type: 'purchaseinvoices',
                    id: invoice.id,
                });
            }

            invoice.items.forEach(item => {
                const itemcost = parseFloat(item.itemcost) || 0;
                const itemquantity = parseFloat(item.itemquantity) || 0;
                const itemuom = item.itemuom;
                const itemtotal = itemquantity * itemcost;

                if (!cost[item.accountid]) {
                    cost[item.accountid] = {
                        quantity: 0,
                        cost: 0
                    };
                }

                cost[item.accountid].quantity += itemquantity;
                cost[item.accountid].cost += itemtotal;

                if (item.accounttype == 'items') {
                    let type = items.find(it => it.id == item.accountid)?.type;

                    if (type == 'inventory') {
                        resultsArray.push({
                            ts: invoice.ts,
                            name: invoice.name,
                            accounttype: 'items',
                            accountid: item.accountid,
                            debit: itemtotal,
                            credit: 0,
                            debitquantity: itemquantity,
                            creditquantity: 0,
                            debituom: itemuom,
                            credituom: '',
                            currencyid: invoice.currencyid,
                            subaccountid: invoice.subaccountid,
                            type: 'purchaseinvoices',
                            id: invoice.id,
                        });
                    }
                    if (type == 'service') {
                        resultsArray.push({
                            ts: invoice.ts,
                            name: invoice.name,
                            accounttype: 'items',
                            accountid: item.accountid,
                            debit: itemtotal,
                            credit: 0,
                            debitquantity: itemquantity,
                            creditquantity: 0,
                            debituom: itemuom,
                            credituom: '',
                            currencyid: invoice.currencyid,
                            subaccountid: invoice.subaccountid,
                            type: 'purchaseinvoices',
                            id: invoice.id,
                        });
                    }
                }
                if (item.accounttype == 'expenseaccounts') {
                    resultsArray.push({
                        ts: invoice.ts,
                        name: invoice.name,
                        accounttype: 'expenseaccounts',
                        accountid: item.accountid,
                        debit: itemtotal,
                        credit: 0,
                        currencyid: invoice.currencyid,
                        subaccountid: invoice.subaccountid,
                        type: 'purchaseinvoices',
                        id: invoice.id,
                    });
                }
                if (item.accounttype == 'assetaccounts') {
                    resultsArray.push({
                        ts: invoice.ts,
                        name: invoice.name,
                        accounttype: 'assetaccounts',
                        accountid: item.accountid,
                        debit: itemtotal,
                        credit: 0,
                        currencyid: invoice.currencyid,
                        subaccountid: invoice.subaccountid,
                        type: 'purchaseinvoices',
                        id: invoice.id,
                    });
                }
            });
        });

    productionorders.forEach(order => {
        order.items.forEach(orderitem => {
            salesinvoices.forEach(invoice => {
                invoice.items.forEach(item => {
                    if (item.accountid === order.itemid) {

                    }
                });
            });
        });
    });

    salesinvoices
        .forEach(invoice => {
            let client = clients.find(client => client.id == invoice.clientid);
            let assetaccountid = clients.find(client => client.id == invoice.clientid)?.assetaccountid;
            let basis = clients.find(client => client.id == invoice.clientid)?.basis;

            if (basis == 'cash') {
                resultsArray.push({
                    ts: invoice.ts,
                    name: invoice.name,
                    accounttype: 'clients',
                    accountid: invoice.clientid,
                    debit: invoice.amount,
                    credit: invoice.amount,
                    currencyid: invoice.currencyid,
                    subaccountid: invoice.subaccountid,
                    type: 'salesinvoices',
                    id: invoice.id,
                });
                resultsArray.push({
                    ts: invoice.ts,
                    name: invoice.name,
                    accounttype: 'assetaccounts',
                    accountid: assetaccountid,
                    debit: invoice.amount,
                    credit: 0,
                    currencyid: invoice.currencyid,
                    subaccountid: invoice.subaccountid,
                    type: 'salesinvoices',
                    id: invoice.id,
                });
            }
            if (basis == 'accrual') {
                resultsArray.push({
                    ts: invoice.ts,
                    name: invoice.name,
                    accounttype: 'clients',
                    accountid: invoice.clientid,
                    debit: invoice.amount,
                    credit: 0,
                    currencyid: invoice.currencyid,
                    subaccountid: invoice.subaccountid,
                    type: 'salesinvoices',
                    id: invoice.id,
                });
                resultsArray.push({
                    ts: invoice.ts,
                    name: invoice.name,
                    accounttype: 'assetaccounts',
                    accountid: assetaccountid,
                    debit: invoice.amount,
                    credit: 0,
                    currencyid: invoice.currencyid,
                    subaccountid: invoice.subaccountid,
                    type: 'salesinvoices',
                    id: invoice.id,
                });
            }

            invoice.items.forEach(item => {
                const itemprice = parseFloat(item.itemprice) || 0;
                const itemquantity = parseFloat(item.itemquantity) || 0;
                const itemuom = item.itemuom;
                const itemtotal = itemquantity * itemprice;

                if (item.accounttype == 'items') {
                    let incomeaccountid = items.find(it => it.id == item.accountid)?.incomeaccountid;
                    let type = items.find(it => it.id == item.accountid)?.type;

                    let averagecost =
                        (cost[item.accountid]?.cost ?? 0) /
                        (cost[item.accountid]?.quantity ?? 1);

                    resultsArray.push({
                        ts: invoice.ts,
                        name: item.description || invoice.name,
                        accounttype: 'incomeaccounts',
                        accountid: incomeaccountid,
                        debit: 0,
                        credit: itemtotal,
                        currencyid: invoice.currencyid,
                        subaccountid: invoice.subaccountid,
                        type: 'salesinvoices',
                        id: invoice.id,
                    });

                    resultsArray.push({
                        ts: invoice.ts,
                        name: item.description || invoice.name,
                        accounttype: 'expenseaccounts',
                        accountid: 'default_expense_account',
                        debit: averagecost,
                        credit: 0,
                        currencyid: invoice.currencyid,
                        subaccountid: invoice.subaccountid,
                        type: 'salesinvoices',
                        id: invoice.id,
                    });

                    if (type == 'inventory') {
                        resultsArray.push({
                            ts: invoice.ts,
                            name: invoice.name,
                            accounttype: 'items',
                            accountid: item.accountid,
                            debit: 0,
                            credit: averagecost,
                            debitquantity: 0,
                            creditquantity: itemquantity,
                            debituom: '',
                            credituom: itemuom,
                            currencyid: invoice.currencyid,
                            subaccountid: invoice.subaccountid,
                            type: 'salesinvoices',
                            id: invoice.id,
                        });
                    }
                    if (type == 'service') {
                        resultsArray.push({
                            ts: invoice.ts,
                            name: invoice.name,
                            accounttype: 'items',
                            accountid: item.accountid,
                            debit: 0,
                            credit: averagecost,
                            debitquantity: 0,
                            creditquantity: itemquantity,
                            debituom: '',
                            credituom: itemuom,
                            currencyid: invoice.currencyid,
                            subaccountid: invoice.subaccountid,
                            type: 'salesinvoices',
                            id: invoice.id,
                        });
                    }
                }
                if (item.accounttype == 'liabilityaccounts') {
                    resultsArray.push({
                        ts: invoice.ts,
                        name: item.description || invoice.name,
                        accounttype: 'liabilityaccounts',
                        accountid: item.accountid,
                        debit: 0,
                        credit: itemtotal,
                        currencyid: invoice.currencyid,
                        subaccountid: invoice.subaccountid,
                        type: 'salesinvoices',
                        id: invoice.id,
                    });
                }
            });
        });

    resultsArray.sort((a, b) => a.ts - b.ts);

    return resultsArray;
}

export function getledgerbalance(accountledgers, exchangerates, selectedcurrency, type) {
    let totalDebit = 0;
    let totalCredit = 0;

    for (let i = 0; i < accountledgers.length; i++) {
        const item = accountledgers[i];

        if (item.currencyid !== selectedcurrency) {
            const rate = findNearestExchangeRate(exchangerates, item.ts, item.currencyid, selectedcurrency).exchangerate;
            totalDebit += Number(item.debit) * rate || 0;
            totalCredit += Number(item.credit) * rate || 0;
        }
        else {
            totalDebit += Number(item.debit) || 0;
            totalCredit += Number(item.credit) || 0;
        }
    }
    switch (type) {
        case "clients":
        case "cashaccounts":
        case "assetaccounts":
        case "expenseaccounts":
        case "items":
            return totalDebit - totalCredit;

        case "suppliers":
        case "staff":
        case "liabilityaccounts":
        case "equityaccounts":
        case "incomeaccounts":
            return totalCredit - totalDebit;
    }
}

export function getledgercount(accountledgers) {
    let totalDebit = 0;
    let totalCredit = 0;

    for (let i = 0; i < accountledgers.length; i++) {
        const item = accountledgers[i];

        totalDebit += Number(item.debitquantity) || 0;
        totalCredit += Number(item.creditquantity) || 0;
    }

    return totalDebit - totalCredit;
}